import React from 'react'
import { Position, PositionsContainer, Content, Bet } from './PositionStyles'
import { ReactComponent as RAISE } from '../../../lib/assets/raise.svg'
import { Currencies } from '@orbital/games-frontend-library'

function PositionButton({
  title,
  content,
  active,
  disabled,
  withBet,
  clickHandler,
  // win,
  betReply,
  currency,
  precision,
}: any) {
  return (
    <PositionsContainer
      active={active}
      disabled={disabled}
      onClick={clickHandler}
      withBet={withBet}
    >
      <Position active={active} withBet={withBet} disabled={disabled}>
        <Content withBet={withBet} active={active}>
          {title === 'RAISE' && content === '0' ? <RAISE /> : content}
        </Content>
      </Position>
      <span>{title}</span>
      {betReply && content !== '0' && content !== 'AA' && (
        <Bet>
          <span>{Currencies[currency]}</span>
          <span>{Number(content).toFixed(precision)}</span>
        </Bet>
      )}
    </PositionsContainer>
  )
}

export default PositionButton
